import { connect, ConnectedProps } from 'react-redux'

import {
  setAccordionExpandedNodeTitle,
  setAccordionExpandedNodeId,
  updateExpandedNodeIdState,
  setAccordionState,
  pageToggleRight,
  setAccordionGroup,
  handleExpandedTitleOnClick,
  setAccordionBreadCrumbClicked,
  setAccordionUrlNode,
  SetAccordionStateProps
} from 'redux/actions'
import AccordionWrapper from 'components/accordion'
import { AppDispatch, RootState } from 'redux/store'
import { AccordionGroup } from 'interfaces/accordion'

const mapStateToProps = (state: RootState): { flavour: RootState['layout']['flavour'], isMouseAbilityOpen: RootState['page']['isMouseAbilityOpen'] } => ({
  flavour: state.layout.flavour,
  isMouseAbilityOpen: state.page.isMouseAbilityOpen
})

const mapDispatchToProps = (dispatch: AppDispatch): {
  pageToggleRight: (force: boolean) => any
  setAccordionExpandedNodeId: (expandedNodeId: string) => ReturnType<AppDispatch>
  setAccordionExpandedNodeTitle: (expandedNodeTitle: string) => ReturnType<AppDispatch>
  updateExpandedNodeIdState: (id: string, value: string) => any
  setAccordionGroup: (group: number | AccordionGroup[]) => ReturnType<AppDispatch>
  setAccordionState: (props: SetAccordionStateProps) => any
  handleExpandedTitleOnClick: () => any
  setAccordionBreadCrumbClicked: (breadCrumbClicked: boolean) => ReturnType<AppDispatch>
  setAccordionUrlNode: (urlNode: string) => ReturnType<AppDispatch>
} => ({
  pageToggleRight: (force: boolean) => dispatch(pageToggleRight(force) as any), // FIX ME remove as any
  setAccordionExpandedNodeId: (expandedNodeId: string) => dispatch(setAccordionExpandedNodeId(expandedNodeId)),
  setAccordionExpandedNodeTitle: (expandedNodeTitle: string) => dispatch(setAccordionExpandedNodeTitle(expandedNodeTitle)),
  updateExpandedNodeIdState: (id: string, value: string) => dispatch(updateExpandedNodeIdState(id, value) as any), // FIX ME remove as any
  setAccordionGroup: (group: number | AccordionGroup[]) => dispatch(setAccordionGroup(group)),
  setAccordionState: (props: SetAccordionStateProps) => dispatch(setAccordionState(props) as any), // FIX ME remove as any
  handleExpandedTitleOnClick: () => dispatch(handleExpandedTitleOnClick() as any), // FIX ME remove as any
  setAccordionBreadCrumbClicked: (breadCrumbClicked: boolean) => dispatch(setAccordionBreadCrumbClicked(breadCrumbClicked)),
  setAccordionUrlNode: (urlNode: string) => dispatch(setAccordionUrlNode(urlNode))
})

export const connector = connect(mapStateToProps, mapDispatchToProps)
export type AccordionWrapperContainerProps = ConnectedProps<typeof connector>

export default connector(AccordionWrapper)
